import React, { useEffect, useState } from "react";

const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];

const AttachmentPreviewModal = ({
  file,
  files = [],
  currentIndex = 0,
  onNavigate,
  onClose
}) => {
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    setZoom(1);
    setRotation(0);
  }, [file?.url]);

  if (!file) return null;

  const extension = (file.fileName || file.url || "").split(".").pop()?.toLowerCase();
  const isImage = imageExtensions.includes(extension);
  const hasMultipleFiles = files.length > 1;
  const canGoPrevious = hasMultipleFiles && currentIndex > 0;
  const canGoNext = hasMultipleFiles && currentIndex < files.length - 1;

  const zoomIn = () => setZoom((value) => Math.min(value + 0.25, 3));
  const zoomOut = () => setZoom((value) => Math.max(value - 0.25, 0.5));
  const rotate = () => setRotation((value) => (value + 90) % 360);
  const download = () => {
    const link = document.createElement("a");
    link.href = file.url;
    link.download = file.fileName || "attachment";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };
  const goPrevious = () => {
    if (canGoPrevious) onNavigate(currentIndex - 1);
  };
  const goNext = () => {
    if (canGoNext) onNavigate(currentIndex + 1);
  };

  return (
    <>
      <div className="modal fade show d-block attachment-preview-modal" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header attachment-preview-header py-2">
              <h6 className="modal-title text-truncate">{file.fileName}</h6>
              <div className="attachment-preview-toolbar">
                {hasMultipleFiles && (
                  <>
                    <button
                      className="attachment-preview-tool"
                      type="button"
                      onClick={goPrevious}
                      disabled={!canGoPrevious}
                      title="Previous attachment"
                      aria-label="Previous attachment"
                    >
                      <i className="bi bi-chevron-left" aria-hidden="true"></i>
                    </button>
                    <span className="attachment-preview-count">
                      {currentIndex + 1} / {files.length}
                    </span>
                    <button
                      className="attachment-preview-tool"
                      type="button"
                      onClick={goNext}
                      disabled={!canGoNext}
                      title="Next attachment"
                      aria-label="Next attachment"
                    >
                      <i className="bi bi-chevron-right" aria-hidden="true"></i>
                    </button>
                  </>
                )}
                <button
                  className="attachment-preview-tool"
                  type="button"
                  onClick={zoomOut}
                  title="Zoom out"
                  aria-label="Zoom out"
                >
                  <i className="bi bi-dash-lg" aria-hidden="true"></i>
                </button>
                <button
                  className="attachment-preview-tool"
                  type="button"
                  onClick={zoomIn}
                  title="Zoom in"
                  aria-label="Zoom in"
                >
                  <i className="bi bi-plus-lg" aria-hidden="true"></i>
                </button>
                <button
                  className="attachment-preview-tool"
                  type="button"
                  onClick={rotate}
                  title="Rotate"
                  aria-label="Rotate"
                >
                  <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </button>
                <button
                  className="attachment-preview-tool"
                  type="button"
                  onClick={download}
                  title="Download attachment"
                  aria-label="Download attachment"
                >
                  <i className="bi bi-download" aria-hidden="true"></i>
                </button>
              </div>
              <button type="button" className="btn-close attachment-preview-close" onClick={onClose}></button>
            </div>

            <div className="modal-body attachment-preview-body">
              {isImage ? (
                <img
                  src={file.url}
                  alt={file.fileName}
                  className="attachment-preview-image"
                  onClick={zoomIn}
                  style={{
                    transform: `scale(${zoom}) rotate(${rotation}deg)`
                  }}
                />
              ) : (
                <iframe
                  key={file.url}
                  title={file.fileName}
                  src={file.url}
                  className="attachment-preview-frame"
                  style={{
                    transform: `scale(${zoom}) rotate(${rotation}deg)`
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show attachment-preview-backdrop"></div>
    </>
  );
};

export default AttachmentPreviewModal;
